import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Form, Input, Button, Select } from "antd";
import { createClient } from "../../actions/ClientAction";
import {
  getClients,
  getTypeClients,
  getTypeBusinessClients
} from "../../actions/ClientsAction";
import { RequiredField } from "../required-field/RequiredField";
import { sendNotification, isEmail } from "../../utils";
import ActivationModules from "../modules-activation/ActivationModules";
//import {useState} from "react";

const { Option } = Select;
const services = [
  {
    value: "Servicios de Publicidad"
  },
  {
    value: "Producción Audiovisual"
  },
  {
    value: "Imprenta"
  },
  {
    value: "Animación Digital"
  },
  {
    value: "Servicios/Asesorías"
  },
  {
    value: "Diseño Gráfico"
  },
  {
    value: "Community Manager"
  },
  {
    value: "Web"
  },
  {
    value: "Arquitectura"
  },
  {
    value: "Estrategias de Mercadeo"
  },
  {
    value: "Ilustraciones"
  },
  {
    value: "Estudiante"
  },
  {
    value: "Otro"
  }
];
export class CreateClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dni: "",
      companyName: "",
      agent: "",
      phone: "",
      email: "",
      clientType: "",
      businessType: "",
      modules: [],
      dartCustomField: "",
      contractedUsers: null,
      contractedSpace: null,
      options: [],
      optionBusiness: [],
      listTypeClient: [],
      listTypeBusinessClient: services
    };
  }

  componentDidMount() {
    this.props.getTypeClients();
    this.props.getTypeBusinessClients();
    const { listTypeClient } = this.props;
    const { listTypeBusinessClient } = this.state;
    this.setState({
      options: listTypeClient.map((r, k) => (
        <Option key={k} value={r._id} uid={r._id}>
          {r.name}
        </Option>
      )),
      optionBusiness: listTypeBusinessClient.map((r, k) => (
        <Option key={k} value={r.value} uid={r.value}>
          {r.value}
        </Option>
      ))
    });
  }

  componentDidUpdate(prevProps) {
    const { clientCreate, intl } = this.props;

    if (clientCreate && clientCreate !== prevProps.clientCreate) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "client_created_successfully" })
      );
      this.props.handleHideCreateClient();
    }
  }

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleSendModules = modules => {
    this.setState({ modules: modules });
  };

  handleOnClientTypeChange = value => {
    this.setState({
      clientType: value
    });
  };

  handleOnBusinessTypeChange = value => {
    this.setState({
      businessType: value
    });
  };

  handleCreateClient = data => {
    const { activePage, intl } = this.props;
    const {
      companyName,
      dni,
      email,
      agent,
      phone,
      modules,
      dartCustomField,
      contractedUsers,
      contractedSpace,
      clientType,
      businessType
    } = this.state;

    if (
      !companyName ||
      !dni ||
      !dartCustomField ||
      !contractedUsers ||
      !contractedSpace ||
      !clientType ||
      !businessType
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "enter_required_fields" })
      );
    } else if (!isEmail(email)) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "not_valid_email" })
      );
    } else {
      this.props.createClient(
        dni,
        companyName,
        agent,
        phone,
        email,
        modules,
        dartCustomField.trim(),
        contractedUsers,
        contractedSpace,
        clientType,
        businessType
      );
      setTimeout(() => {
        this.props.getClients(activePage);
        this.props.getTypeClients();
        this.props.getTypeBusinessClients();
      }, 1000);
    }
  };

  render() {
    const { intl, handleHideCreateClient } = this.props;
    const {
      data,
      dni,
      companyName,
      agent,
      phone,
      email,
      dartCustomField,
      contractedUsers,
      contractedSpace,
      options,
      optionBusiness
    } = this.state;

    return (
      <Form layout="vertical">
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "rut_company" })} />
          <Input name="dni" value={dni} onChange={this.handleInputOnChange} />
        </Form.Item>
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "business_name" })} />
          <Input
            name="companyName"
            value={companyName}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "contact" })}</span>
          <Input
            name="agent"
            value={agent}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "phone" })}</span>
          <Input
            name="phone"
            value={phone}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "email" })}</span>
          <Input
            name="email"
            value={email}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "type_clients" })} />
          <Select onChange={this.handleOnClientTypeChange}>{options}</Select>
        </Form.Item>
        <Form.Item value={intl.formatMessage({ id: "all" })}>
          <RequiredField name={intl.formatMessage({ id: "type_business" })} />
          <Select onChange={this.handleOnBusinessTypeChange}>
            {optionBusiness}
          </Select>
        </Form.Item>
        <Form.Item>
          <RequiredField
            name={intl.formatMessage({ id: "dart_custom_field" })}
          />
          <Input
            name="dartCustomField"
            value={dartCustomField}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <RequiredField
            name={intl.formatMessage({ id: "contracted_users" })}
          />
          <Input
            name="contractedUsers"
            value={contractedUsers}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <RequiredField
            name={intl.formatMessage({ id: "contracted_space" })}
          />
          <Input
            name="contractedSpace"
            value={contractedSpace}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "modules" })} </span>
          <ActivationModules
            isIndividualComponent={false}
            handleSendModules={this.handleSendModules}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={() => this.handleCreateClient(data)}>
            {intl.formatMessage({ id: "create" })}
          </Button>
          <Button
            style={{ marginLeft: "8px" }}
            onClick={handleHideCreateClient}
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Form.Item>
        <span style={{ color: "red" }}>(*) </span>
        <span>{intl.formatMessage({ id: "required_fields" })}</span>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  workclient: state.client.workclient,
  clientCreate: state.client.clientCreate,
  listTypeClient: state.clients.listTypeClient,
  listTypeBusinessClient: state.clients.listTypeBusinessClient
});

const mapDispatchToProps = {
  createClient,
  getClients,
  getTypeClients,
  getTypeBusinessClients
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateClient))
);
